var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons (Decorative)/question-mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M66,1 C65.4477153,1 65,1.44771525 65,2 C65,2.55228475 65.4477153,3 66,3 C66.5522847,3 67,2.55228475 67,2 C67,1.44771525 66.5522847,1 66,1 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,0 C69.790861,0 68,1.790861 68,4 C68,6.209139 69.790861,8 72,8 C74.209139,8 76,6.209139 76,4 C76,1.790861 74.209139,0 72,0 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,63 C68.8954305,63 68,63.8954305 68,65 C68,66.1045695 68.8954305,67 70,67 C71.1045695,67 72,66.1045695 72,65 C72,63.8954305 71.1045695,63 70,63 Z M4,48 C1.790861,48 0,49.790861 0,52 C0,54.209139 1.790861,56 4,56 C6.209139,56 8,54.209139 8,52 C8,49.790861 6.209139,48 4,48 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,55 C9.44771525,55 9,55.4477153 9,56 C9,56.5522847 9.44771525,57 10,57 C10.5522847,57 11,56.5522847 11,56 C11,55.4477153 10.5522847,55 10,55 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-(Decorative)/question-mark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-question_mark",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,16 C0.8954305,16 0,16.8954305 0,18 C0,19.1045695 0.8954305,20 2,20 C3.1045695,20 4,19.1045695 4,18 C4,16.8954305 3.1045695,16 2,16 Z",
    id: "Path",
    fill: "#EE3E54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F5684F",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF7D54",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF6755",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFA949",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39,2 C18.5654643,2 2,18.5654643 2,39 C2,59.4345357 18.5654643,76 39,76 C59.4345357,76 76,59.4345357 76,39 C76,18.5654643 59.4345357,2 39,2 Z",
    id: "Path",
    fill: "#FCE0A2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F5684F",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF7D54",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF6755",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFA949",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76,11 C74.8954305,11 74,11.8954305 74,13 C74,14.1045695 74.8954305,15 76,15 C77.1045695,15 78,14.1045695 78,13 C78,11.8954305 77.1045695,11 76,11 Z",
    id: "Path",
    fill: "#EE3E54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F5684F",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF7D54",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF6755",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFA949",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14,74 C12.8954305,74 12,74.8954305 12,76 C12,77.1045695 12.8954305,78 14,78 C15.1045695,78 16,77.1045695 16,76 C16,74.8954305 15.1045695,74 14,74 Z",
    id: "Path",
    fill: "#EE3E54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,40 C6.11928813,40 5,41.1192881 5,42.5 C5,43.8807119 6.11928813,45 7.5,45 C8.88071187,45 10,43.8807119 10,42.5 C10,41.1192881 8.88071187,40 7.5,40 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F5684F",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF7D54",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF6755",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFA949",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69,22 C68.4477153,22 68,22.4477153 68,23 C68,23.5522847 68.4477153,24 69,24 C69.5522847,24 70,23.5522847 70,23 C70,22.4477153 69.5522847,22 69,22 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.000000, 11.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.873,38.043 L11.873,36.197 C11.873,30.173 15.95,26.812 19.547,23.847 C22.572,21.353 25.431,18.997 25.431,15.462 C25.431,11.788 22.358,7.988 17.216,7.988 C12.212,7.988 8.831,10.869 8.255,15.555 L0.737,15.555 C1.358,6.851 7.797,1.48 17.708,1.48 C27.478,1.48 34.3,7.089 34.3,15.121 C34.3,20.257 31.927,24.054 26.604,27.433 C22.006,30.352 21.32,34.639 21.32,36.934 L21.32,38.042 L11.873,38.042 L11.873,38.043 Z",
    id: "Path",
    fill: "#A1D3A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.708,2.182 C27.214,2.182 33.6,7.382 33.6,15.122 C33.6,19.992 31.327,23.606 26.228,26.842 C21.348,29.941 20.619,34.495 20.619,36.935 L20.619,37.343 L12.573,37.343 L12.573,36.198 C12.573,30.503 16.345,27.394 19.992,24.388 C23.149,21.786 26.13,19.329 26.13,15.463 C26.13,11.445 22.796,7.29 17.216,7.29 C12.127,7.29 8.497,10.217 7.654,14.858 L1.502,14.858 C2.391,6.889 8.348,2.182 17.708,2.182 M17.708,0.782 C6.471,0.782 0.303,7.291 0,16.257 L8.892,16.257 C9.195,11.64 12.336,8.689 17.216,8.689 C21.984,8.689 24.73,12.17 24.73,15.462 C24.73,22.694 11.173,24.783 11.173,36.197 L11.173,38.742 L22.019,38.742 L22.019,36.934 C22.019,33.866 23.27,30.378 26.978,28.023 C32.035,24.815 35,20.911 35,15.122 C35,6.76 28.076,0.782 17.708,0.782 L17.708,0.782 Z",
    id: "Shape",
    fill: "#472B29"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.596,12.119 C3.493,12.119 0.97,9.595 0.97,6.492 C0.97,3.389 3.493,0.866 6.596,0.866 C9.699,0.866 12.223,3.389 12.223,6.492 C12.223,9.595 9.698,12.119 6.596,12.119 Z",
    id: "Path",
    fill: "#A1D3A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.596,1.566 C9.313,1.566 11.523,3.776 11.523,6.493 C11.523,9.21 9.313,11.42 6.596,11.42 C3.879,11.42 1.669,9.21 1.669,6.493 C1.669,3.776 3.88,1.566 6.596,1.566 M6.596,0.166 C3.102,0.166 0.269,2.999 0.269,6.493 C0.269,9.987 3.102,12.82 6.596,12.82 C10.09,12.82 12.923,9.987 12.923,6.493 C12.923,2.998 10.09,0.166 6.596,0.166 L6.596,0.166 Z",
    id: "Shape",
    fill: "#472B29"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44.875,16.429 C44.832,16.429 44.788,16.423 44.744,16.411 C43.201,15.993 41.507,15.781 39.708,15.781 C39.432,15.781 39.208,15.557 39.208,15.281 C39.208,15.005 39.432,14.781 39.708,14.781 C41.595,14.781 43.378,15.005 45.006,15.446 C45.273,15.518 45.43,15.793 45.358,16.059 C45.297,16.282 45.096,16.429 44.875,16.429 Z",
    id: "Path",
    fill: "#472B29",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.849,19.818 C50.716,19.818 50.584,19.765 50.486,19.662 C49.872,19.011 49.144,18.426 48.324,17.923 C47.951,17.694 47.554,17.482 47.148,17.289 C46.899,17.171 46.792,16.873 46.91,16.623 C47.029,16.373 47.328,16.269 47.576,16.385 C48.014,16.592 48.442,16.823 48.847,17.071 C49.743,17.621 50.538,18.261 51.213,18.975 C51.402,19.176 51.394,19.493 51.193,19.682 C51.096,19.773 50.972,19.818 50.849,19.818 Z",
    id: "Path",
    fill: "#472B29",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.618,46.743 C40.598,46.743 40.579,46.742 40.559,46.74 C40.285,46.708 40.088,46.459 40.12,46.185 C40.632,41.814 43.016,38.072 46.835,35.647 C51.156,32.904 53,30.056 53,26.122 C53,24.966 52.813,23.859 52.446,22.835 C52.298,22.42 52.117,22.013 51.907,21.624 C51.776,21.381 51.867,21.077 52.11,20.946 C52.356,20.817 52.656,20.907 52.788,21.149 C53.021,21.583 53.223,22.036 53.388,22.498 C53.794,23.631 54,24.851 54,26.122 C54,30.44 52.018,33.542 47.37,36.491 C43.811,38.752 41.589,42.235 41.114,46.301 C41.084,46.556 40.868,46.743 40.618,46.743 Z",
    id: "Path",
    fill: "#472B29",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,65 C38.224,65 38,64.776 38,64.5 C38,64.224 38.224,64 38.5,64 C39.086,64 39.634,63.804 40.086,63.433 C40.667,62.956 41,62.251 41,61.5 C41,60.121 39.879,59 38.5,59 C37.832,59 37.205,59.26 36.732,59.732 C36.537,59.927 36.22,59.927 36.025,59.732 C35.83,59.537 35.83,59.22 36.025,59.025 C36.687,58.364 37.565,58 38.5,58 C40.43,58 42,59.57 42,61.5 C42,62.552 41.534,63.537 40.721,64.206 C40.097,64.718 39.309,65 38.5,65 Z",
    id: "Path",
    fill: "#472B29",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.8f9949a4222b3e9b59c5b835b8ceba5c.svg";
export { ForwardRef as ReactComponent };